import {JobCategory, JobCategoryTypes} from "@betrue/shared/interfaces";
import {v4 as uuidv4} from 'uuid';


export const JOBS_CATEGORIES = [
  {

    id: uuidv4(), category: JobCategoryTypes.TECH,
    label: "Tech",
    jobs: [
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Développeur Web Back-end",
        baseSkills: [
          {"label": "JavaScript"},
          {"label": "PHP"},
          {"label": "HTML5"},
          {"label": "CSS3"},
          {"label": "MySQL"},
          {"label": "Java"},
          {"label": "Node.js"},
          {"label": "jQuery"},
          {"label": "Wordpress"},
          {"label": "Git"}]
      },
      {
        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Développeur Web Front-end",
        baseSkills: [
          {"label": "JavaScript"},
          {"label": "HTML5"},
          {"label": "CSS3"},
          {"label": "Wordpress"},
          {"label": "React.js"},
          {"label": "PHP"},
          {"label": "Node.js"},
          {"label": "Développement Front-End"},
          {"label": "jQuery"},
          {"label": "Git"}]

      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Développeur CMS",
        baseSkills: [
          {"label": "Wordpress"},
          {"label": "CSS3"},
          {"label": "HTML5"},
          {"label": "PHP"},
          {"label": "SEO"},
          {"label": "Développement web"},
          {"label": "JavaScript"},
          {"label": "Site vitrine"},
          {"label": "Webdesign"},
          {"label": "E-commerce"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Développeur Mobile",
        baseSkills: [
          {"label": "Android"},
          {"label": "iOS"},
          {"label": "Swift"},
          {"label": "Java"},
          {"label": "Développement Mobile"},
          {"label": "Git"},
          {"label": "JavaScript"},
          {"label": "Objective-C"},
          {"label": "Application Mobile"},
          {"label": "Kotlin"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Intégrateur Web",
        baseSkills: [
          {"label": "CSS3"},
          {"label": "HTML5"},
          {"label": "Wordpress"},
          {"label": "JavaScript"},
          {"label": "Intégration web"},
          {"label": "PHP"},
          {"label": "jQuery"},
          {"label": "Adobe Photoshop"},
          {"label": "SEO"},
          {"label": "Bootstrap"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Ingénieur logiciel",
        baseSkills: [
          {"label": "Java"},
          {"label": "Python"},
          {"label": "C++"},
          {"label": "JavaScript"},
          {"label": "C#"},
          {"label": "Git"},
          {"label": "SQL"},
          {"label": "Linux"},
          {"label": "PHP"},
          {"label": "C"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Administrateur Système et Réseaux",
        baseSkills: [
          {"label": "Linux"},
          {"label": "Windows Server"},
          {"label": "Administration système"},
          {"label": "Administration réseaux"},
          {"label": "VMWARE"},
          {"label": "Active Directory"},
          {"label": "Cisco"},
          {"label": "Ansible"},
          {"label": "Virtualisation"},
          {"label": "Docker"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "DevOps",
        baseSkills: [
          {"label": "Docker"},
          {"label": "Kubernetes"},
          {"label": "Ansible"},
          {"label": "Amazon Web Services"},
          {"label": "Linux"},
          {"label": "DevOps"},
          {"label": "Terraform"},
          {"label": "Python"},
          {"label": "Jenkins"},
          {"label": "Git"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Architecte & Urbaniste SI",
        baseSkills: [
          {"label": "Architecture SI"},
          {"label": "Java"},
          {"label": "Docker"},
          {"label": "Gestion de projet"},
          {"label": "JavaScript"},
          {"label": "Autocad"},
          {"label": "Linux"},
          {"label": "Management d'équipe"},
          {"label": "Oracle"},
          {"label": "Amazon Web Services"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Testeur (QA)",
        baseSkills: [
          {"label": "Atlassian JIRA"},
          {"label": "Méthode agile"},
          {"label": "User Testing"},
          {"label": "Selenium"},
          {"label": "QA testing"},
          {"label": "Scrum"},
          {"label": "Java"},
          {"label": "SQL"},
          {"label": "Recette fonctionnelle"},
          {"label": "Gestion de projet"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Expert virtualisation",
        baseSkills: [
          {"label": "VMWARE"},
          {"label": "Virtualisation"},
          {"label": "Windows Server"},
          {"label": "Citrix"},
          {"label": "Linux"},
          {"label": "Cisco"},
          {"label": "Active Directory"},
          {"label": "Netscaler"},
          {"label": "Stockage"},
          {"label": "Microsoft Azure"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Expert en cyber sécurité",
        baseSkills: [
          {"label": "Cybersécurité"},
          {"label": "PenTest"},
          {"label": "Linux"},
          {"label": "Audit"},
          {"label": "Gestion de projet"},
          {"label": "Analyse de risques"},
          {"label": "Formation"},
          {"label": "ISO 27001"},
          {"label": "Python"},
          {"label": "Administration réseaux"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Développeur iOT",
        baseSkills: [
          {"label": "Python"},
          {"label": "Internet des objets"},
          {"label": "C++"},
          {"label": "C"},
          {"label": "Systèmes embarqués"},
          {"label": "Arduino"},
          {"label": "Linux"},
          {"label": "Bluetooth Low Energy"},
          {"label": "Java"},
          {"label": "Raspberry Pi"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Développeur systèmes embarqués",
        baseSkills: [
          {"label": "C"},
          {"label": "C++"},
          {"label": "Python"},
          {"label": "Systèmes embarqués"},
          {"label": "Linux"},
          {"label": "Git"},
          {"label": "Arduino"},
          {"label": "Java"},
          {"label": "Qt"},
          {"label": "STM32"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Cloud Engineer & Architect",
        baseSkills: [
          {"label": "Amazon Web Services"},
          {"label": "Docker"},
          {"label": "Terraform"},
          {"label": "DevOps"},
          {"label": "Python"},
          {"label": "Kubernetes"},
          {"label": "Linux"},
          {"label": "Microsoft Azure"},
          {"label": "Java"},
          {"label": "Ansible"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Administrateur base de données",
        baseSkills: [
          {"label": "SQL Server"},
          {"label": "Oracle"},
          {"label": "SQL"},
          {"label": "Linux"},
          {"label": "MySQL"},
          {"label": "Database administration"},
          {"label": "PostgreSQL"},
          {"label": "PHP"},
          {"label": "Microsoft Excel"},
          {"label": "Java"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "System Reliability Engineer",
        baseSkills: [
          {"label": "Linux"},
          {"label": "DevOps"},
          {"label": "Kubernetes"},
          {"label": "Python"},
          {"label": "Ansible"},
          {"label": "Debian"},
          {"label": "Docker"},
          {"label": "Windows Server"},
          {"label": "LAMP"},
          {"label": "Puppet"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Software developer engineer in Test",
        baseSkills: [
          {"label": "Python"},
          {"label": "Java"},
          {"label": "Selenium"},
          {"label": "Git"},
          {"label": "C++"},
          {"label": "JavaScript"},
          {"label": "Automation"},
          {"label": "C#"},
          {"label": "Méthode agile"},
          {"label": "Jenkins"}]
      },
      {

        id: uuidv4(), category: JobCategoryTypes.TECH,
        label: "Développeur ERP",
        baseSkills: [
          {"label": "JavaScript"},
          {"label": "SQL"},
          {"label": "ERP"},
          {"label": "Gestion de projet"},
          {"label": "C#"},
          {"label": "Python"},
          {"label": "Java"},
          {"label": "WINDEV"},
          {"label": "Abap"},
          {"label": "PHP"}]
      }
    ]
  },
  {
    id: uuidv4(), category: JobCategoryTypes.DATA,
    label: "Expert Data",
    jobs: [
      {
        id: "data_scientist",
        label: "Data Scientist",
        baseSkills: [
          {"label": "Python"},
          {"label": "Machine learning"},
          {"label": "Data science"},
          {"label": "SQL"},
          {"label": "Data visualisation"},
          {"label": "Deep Learning"},
          {"label": "R"},
          {"label": "Scikit-learn"},
          {"label": "Analyse de données"},
          {"label": "TensorFlow"}]
      },
      {
        id: "data_engineer",
        label: "Data Engineer",
        baseSkills: [
          {"label": "Python"},
          {"label": "Spark"},
          {"label": "SQL"},
          {"label": "Java"},
          {"label": "SQL Server"},
          {"label": "Scala"},
          {"label": "Hadoop"},
          {"label": "Big Data"},
          {"label": "Docker"},
          {"label": "Amazon Web Services"}]
      },
      {
        id: "data_analyst",
        label: "Data Analyst",
        baseSkills: [
          {"label": "Microsoft Excel"},
          {"label": "SQL"},
          {"label": "Data visualisation"},
          {"label": "Analyse de données"},
          {"label": "Python"},
          {"label": "Microsoft Power BI"},
          {"label": "Gestion de projet"},
          {"label": "VBA"},
          {"label": "Tableau software"},
          {"label": "Data science"}]
      }
    ]
  },
  {
    id: uuidv4(), category: JobCategoryTypes.VIDEO_GAMES,
    label: "Jeux Vidéo",
    jobs: [
      {
        id: "video_game_developer",
        label: "Développeur jeux vidéos",
        baseSkills: [
          {"label": "Unity 3D"},
          {"label": "C#"},
          {"label": "Unity"},
          {"label": "Jeux vidéos"},
          {"label": "Game design"},
          {"label": "C++"},
          {"label": "Réalité virtuelle"},
          {"label": "JavaScript"},
          {"label": "Android"},
          {"label": "unreal engine"}]
      },
      {
        id: "game_designer",
        label: "Game designer",
        baseSkills: [
          {"label": "Game design"},
          {"label": "Unity 3D"},
          {"label": "Adobe Photoshop"},
          {"label": "Jeux vidéos"},
          {"label": "Level Design"},
          {"label": "User Experience Design"},
          {"label": "Gestion de projet"},
          {"label": "Serious Game"},
          {"label": "Graphisme 3D"},
          {"label": "Adobe Illustrator"}]
      },
      {
        id: "3d_modeler",
        label: "Modeleur 3D",
        baseSkills: [
          {"label": "Adobe Photoshop"},
          {"label": "Graphisme 3D"},
          {"label": "Zbrush"},
          {"label": "Unity 3D"},
          {"label": "Maya"},
          {"label": "Modélisation 3D"},
          {"label": "Substance Painter"},
          {"label": "3dsmax"},
          {"label": "Texturing"},
          {"label": "Blender"}]
      },
      {
        id: "level_designer",
        label: "Level designer",
        baseSkills: [
          {"label": "Graphisme 3D"},
          {"label": "Jeux vidéos"},
          {"label": "Game design"}]
      }
    ]
  },
  {
    id: uuidv4(), category: JobCategoryTypes.PROJECT_MANAGER_AGILE,
    label: "Gestion de projets & Coaching",
    jobs: [
      {
        id: "project_manager",
        label: "Chef de projet digital",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Management d'équipe"},
          {"label": "Gestion de projet web"},
          {"label": "Méthode agile"},
          {"label": "User Experience Design"},
          {"label": "Scrum"},
          {"label": "Transformation digitale"},
          {"label": "Wordpress"},
          {"label": "Product management"},
          {"label": "Stratégie de communication"}]
      },
      {
        id: "mobile_project_manager",
        label: "Chef de projet mobile",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Management d'équipe"},
          {"label": "Méthode agile"},
          {"label": "Application Mobile"},
          {"label": "Product management"},
          {"label": "Android"},
          {"label": "Scrum"},
          {"label": "iOS"},
          {"label": "Gestion de projet technique"},
          {"label": "Atlassian JIRA"}]
      },
      {
        id: "product_manager",
        label: "Product Manager",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Product management"},
          {"label": "Méthode agile"},
          {"label": "Management d'équipe"},
          {"label": "Scrum"},
          {"label": "User Experience Design"},
          {"label": "Gestion de projet web"},
          {"label": "Spécifications fonctionnelles"},
          {"label": "Atlassian JIRA"},
          {"label": "E-commerce"}]
      },
      {
        id: "scrum_master",
        label: "Scrum Master",
        baseSkills: [
          {"label": "Scrum"},
          {"label": "Méthode agile"},
          {"label": "Gestion de projet"},
          {"label": "Kanban"},
          {"label": "Atlassian JIRA"},
          {"label": "Java"},
          {"label": "Coaching"},
          {"label": "Management d'équipe"},
          {"label": "JavaScript"},
          {"label": "Atlassian Confluence"}]
      },
      {
        id: "agile_coach",
        label: "Coach Agile",
        baseSkills: [
          {"label": "Méthode agile"},
          {"label": "Gestion de projet"},
          {"label": "Scrum"},
          {"label": "Coaching"},
          {"label": "Management d'équipe"},
          {"label": "Formation"},
          {"label": "Kanban"},
          {"label": "Product management"},
          {"label": "Coaching individuel"},
          {"label": "Conduite du changement"}]
      },
      {
        id: "it_project_manager",
        label: "Chef de projet SI",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Management d'équipe"},
          {"label": "Méthode agile"},
          {"label": "Conduite du changement"},
          {"label": "AMOA"},
          {"label": "SQL"},
          {"label": "Scrum"},
          {"label": "Formation"},
          {"label": "Spécifications fonctionnelles"},
          {"label": "Gestion de projet technique"}]
      }
    ]
  },
  {
    id: uuidv4(), category: JobCategoryTypes.WEB_GRAPHIC_DESIGN,
    label: "Web & Graphic Design",
    jobs: [
      {
        id: "graphic_designer",
        label: "Graphiste",
        baseSkills: [
          {"label": "Adobe Photoshop"},
          {"label": "Adobe Illustrator"},
          {"label": "Graphisme"},
          {"label": "Design logo"},
          {"label": "Adobe InDesign"},
          {"label": "Illustration"},
          {"label": "Webdesign"},
          {"label": "Identité visuelle"},
          {"label": "Charte graphique"},
          {"label": "Graphisme print"}]
      },
      {
        id: "webdesigner",
        label: "Webdesigner",
        baseSkills: [
          {"label": "Webdesign"},
          {"label": "Wordpress"},
          {"label": "Adobe Photoshop"},
          {"label": "User Interface Design"},
          {"label": "User Experience Design"},
          {"label": "Adobe Illustrator"},
          {"label": "HTML5"},
          {"label": "Graphisme"},
          {"label": "CSS3"},
          {"label": "Design logo"}]
      },
      {
        id: "uxdesigner",
        label: "UX Designer",
        baseSkills: [
          {"label": "User Experience Design"},
          {"label": "User Interface Design"},
          {"label": "Webdesign"},
          {"label": "User Research"},
          {"label": "User Testing"},
          {"label": "Wireframing"},
          {"label": "Adobe Photoshop"},
          {"label": "Sketch"},
          {"label": "Prototype"},
          {"label": "Adobe Illustrator"}]
      },
      {
        id: "ui_designer",
        label: "UI Designer",
        baseSkills: [
          {"label": "User Interface Design"},
          {"label": "User Experience Design"},
          {"label": "Webdesign"},
          {"label": "Adobe Photoshop"},
          {"label": "Adobe Illustrator"},
          {"label": "Graphisme"},
          {"label": "Direction artistique"},
          {"label": "Sketch"},
          {"label": "Design logo"},
          {"label": "Charte graphique"}]
      },
      {
        id: "illustrator",
        label: "Illustrateur",
        baseSkills: [
          {"label": "Illustration"},
          {"label": "Adobe Photoshop"},
          {"label": "Adobe Illustrator"},
          {"label": "Dessin"},
          {"label": "Graphisme"},
          {"label": "Adobe InDesign"},
          {"label": "Design logo"},
          {"label": "Bande dessinée"},
          {"label": "Direction artistique"},
          {"label": "Mise en page"}]
      },
      {
        id: "creative_director",
        label: "Directeur artistique",
        baseSkills: [
          {"label": "Direction artistique"},
          {"label": "Graphisme"},
          {"label": "Adobe Photoshop"},
          {"label": "Webdesign"},
          {"label": "Identité visuelle"},
          {"label": "Design logo"},
          {"label": "Adobe Illustrator"},
          {"label": "Adobe InDesign"},
          {"label": "Charte graphique"},
          {"label": "Illustration"}]
      },

    ]
  },
  {
    id: uuidv4(), category: JobCategoryTypes.PICTURE_SOUND,
    label: "Image & Son",
    jobs: [
      {
        id: "photographer",
        label: "Photographe",
        baseSkills: [
          {"label": "Photographie"},
          {"label": "Retouche photo"},
          {"label": "Adobe Photoshop"},
          {"label": "Adobe Lightroom"},
          {"label": "Portrait"},
          {"label": "Montage vidéo"},
          {"label": "Réalisation vidéo"},
          {"label": "Reportage"},
          {"label": "Evénementiel"},
          {"label": "Adobe Premiere"}]

      },
      {
        id: "director",
        label: "Réalisateur vidéo",
        baseSkills: [
          {"label": "Montage vidéo"},
          {"label": "Réalisation vidéo"},
          {"label": "Adobe Premiere"},
          {"label": "Tournage"},
          {"label": "Photographie"},
          {"label": "Adobe After Effects"},
          {"label": "Vidéo"},
          {"label": "Adobe Photoshop"},
          {"label": "Motion design"},
          {"label": "Film d'entreprise"}]
      },
      {
        id: "sounddesigner",
        label: "Sound Designer",
        baseSkills: [
          {"label": "Sound design"},
          {"label": "Mixage"},
          {"label": "Montage son"},
          {"label": "Composition"},
          {"label": "Avid Pro Tools"},
          {"label": "Musique"},
          {"label": "Post production"},
          {"label": "Mastering"},
          {"label": "Compositeur"},
          {"label": "Composition musicale"}]
      },
      {
        id: "3d_animation",
        label: "Animation 3D",
        baseSkills: [
          {"label": "Animation 3D"},
          {"label": "Graphisme 3D"},
          {"label": "Adobe Photoshop"},
          {"label": "Adobe After Effects"},
          {"label": "Motion design"},
          {"label": "Montage vidéo"},
          {"label": "Illustration 3D"},
          {"label": "Adobe Illustrator"},
          {"label": "Modélisation 3D"},
          {"label": "Maya"}]
      },
      {
        id: "motion_designer",
        label: "Motion Designer",
        baseSkills: [
          {"label": "Motion design"},
          {"label": "Adobe After Effects"},
          {"label": "Adobe Illustrator"},
          {"label": "Adobe Photoshop"},
          {"label": "Montage vidéo"},
          {"label": "Animation"},
          {"label": "Graphisme"},
          {"label": "Direction artistique"},
          {"label": "Adobe Premiere"},
          {"label": "Illustration"}]
      },
      {
        id: "voice_over",
        label: "Voix off",
        baseSkills: [
          {"label": "voix off"},
          {"label": "Home studio"},
          {"label": "voice over"},
          {"label": "Publicité"},
          {"label": "Narration"},
          {"label": "Doublage"},
          {"label": "E-learning"},
          {"label": "Montage son"},
          {"label": "Voix off femme"},
          {"label": "podcast"}]
      },
      {
        id: "video_editor",
        label: "Monteur vidéo",
        baseSkills: [
          {"label": "Montage vidéo"},
          {"label": "Adobe Premiere"},
          {"label": "Réalisation vidéo"},
          {"label": "Adobe After Effects"},
          {"label": "Adobe Photoshop"},
          {"label": "Motion design"},
          {"label": "Vidéo"},
          {"label": "Montage son"},
          {"label": "Post production"},
          {"label": "Photographie"}]
      },
      {
        id: "photo_editor",
        label: "Retoucheur",
        baseSkills: [
          {"label": "Retouche photo"},
          {"label": "Adobe Photoshop"},
          {"label": "Montage photo"},
          {"label": "Photographie"},
          {"label": "Adobe Illustrator"},
          {"label": "Adobe Lightroom"},
          {"label": "Montage vidéo"},
          {"label": "Adobe InDesign"},
          {"label": "Chromie"},
          {"label": "Adobe Premiere"}]
      },
      {
        id: "sound_engineer",
        label: "Ingénieur du son",
        baseSkills: [
          {"label": "Mixage"},
          {"label": "Montage son"},
          {"label": "Sound design"},
          {"label": "Avid Pro Tools"},
          {"label": "Ingénieur du son"},
          {"label": "Enregistrement"},
          {"label": "Mastering"},
          {"label": "Post production"},
          {"label": "Prise de son"},
          {"label": "Mixage Son"}]
      }
    ]
  },
  {
    id: uuidv4(), category: JobCategoryTypes.MARKETING,
    label: "Marketing",
    jobs: [
      {
        id: "marketing_consultant",
        label: "Consultant stratégie marketing",
        baseSkills: [
          {"label": "Marketing"},
          {"label": "Stratégie de communication"},
          {"label": "Stratégie webmarketing"},
          {"label": "Réseaux sociaux"},
          {"label": "SEO"},
          {"label": "Facebook Marketing"},
          {"label": "Gestion de projet"},
          {"label": "Marketing de contenu"},
          {"label": "Communication digitale"},
          {"label": "Google Analytics"}]
      },
      {
        id: "crm_consultant",
        label: "Consultant marketing relationnel / CRM",
        baseSkills: [
          {"label": "CRM"},
          {"label": "Gestion de projet"},
          {"label": "Email marketing"},
          {"label": "Marketing"},
          {"label": "Emailing"},
          {"label": "Salesforce"},
          {"label": "Stratégie de communication"},
          {"label": "Stratégie webmarketing"},
          {"label": "Marketing de contenu"},
          {"label": "Google Analytics"}]
      },
      {
        id: "seo_consultant",
        label: "Consultant SEO",
        baseSkills: [
          {"label": "SEO"},
          {"label": "Audit SEO"},
          {"label": "Rédaction SEO"},
          {"label": "Netlinking SEO"},
          {"label": "Google Analytics"},
          {"label": "Wordpress"},
          {"label": "Rédaction web"},
          {"label": "Google AdWords"},
          {"label": "Google Search Console"},
          {"label": "SEA"}]
      },
      {
        id: "webmarketing_consultant",
        label: "Traffic Manager",
        baseSkills: [
          {"label": "Google AdWords"},
          {"label": "Facebook Marketing"},
          {"label": "SEA"},
          {"label": "Google Analytics"},
          {"label": "SEO"},
          {"label": "Stratégie webmarketing"},
          {"label": "Webmarketing"},
          {"label": "Réseaux sociaux"},
          {"label": "Acquisition trafic"},
          {"label": "Instagram Marketing"}]
      },
      {
        id: "growth_hacker",
        label: "Growth Hacker",
        baseSkills: [
          {"label": "Growth hacking"},
          {"label": "Facebook Marketing"},
          {"label": "Génération de leads"},
          {"label": "SEO"},
          {"label": "Google Analytics"},
          {"label": "Stratégie webmarketing"},
          {"label": "Google AdWords"},
          {"label": "Email marketing"},
          {"label": "Acquisition trafic"},
          {"label": "SEA"}]
      },
      {
        id: "revenue_manager",
        label: "Revenue Manager",
        baseSkills: [
          {"label": "Revenue Management"},
          {"label": "Stratégie commerciale"},
          {"label": "Microsoft Excel"},
          {"label": "Email marketing"},
          {"label": "Analyse de données"},
          {"label": "Business plan"},
          {"label": "Management d'équipe"},
          {"label": "Gestion de projet"},
          {"label": "CRM"},
          {"label": "Pricing"}]
      },
      {
        id: "e_merchandiser",
        label: "E-merchandiser",
        baseSkills: [
          {"label": "E-commerce"},
          {"label": "Facebook Marketing"},
          {"label": "Réseaux sociaux"},
          {"label": "Shopify"},
          {"label": "Email marketing"},
          {"label": "SEO"},
          {"label": "Rédaction web"},
          {"label": "Wordpress"},
          {"label": "Community management"},
          {"label": "Google Analytics"}]
      },
      {
        id: "conversion_rate_optimizer",
        label: "Conversion Rate Optimizer",
        baseSkills: [
          {"label": "Copywriting"},
          {"label": "Email marketing"},
          {"label": "Emailing"},
          {"label": "Rédaction web"},
          {"label": "Page de vente"},
          {"label": "Google Analytics"},
          {"label": "Marketing"},
          {"label": "E-commerce"},
          {"label": "Conception rédaction"},
          {"label": "séquence email"}]
      },
      {
        id: "analytics_consultant",
        label: "Consultant analytics",
        baseSkills: [
          {"label": "Google Analytics"},
          {"label": "SEO"},
          {"label": "Google AdWords"},
          {"label": "Google Tag Manager"},
          {"label": "Webmarketing"},
          {"label": "Web analytics"},
          {"label": "Facebook Marketing"},
          {"label": "SEA"},
          {"label": "Stratégie webmarketing"},
          {"label": "E-commerce"}]
      }
    ]
  },
  {
    id: uuidv4(), category: JobCategoryTypes.COMMUNICATION,
    label: "Communication",
    jobs: [
      {
        id: "translator",
        label: "Traducteur",
        baseSkills: [
          {"label": "Traduction Français Anglais"},
          {"label": "Traduction"},
          {"label": "Relecture"},
          {"label": "Traduction Anglais Français"},
          {"label": "Rédaction"},
          {"label": "Rédaction web"},
          {"label": "Anglais"},
          {"label": "Correction"},
          {"label": "Français"},
          {"label": "Traduction Espagnol Français"}]
      },
      {
        id: "pr_consultant",
        label: "Consultant Relation Presse",
        baseSkills: [
          {"label": "Relations presse"},
          {"label": "Stratégie de communication"},
          {"label": "Rédaction"},
          {"label": "Community management"},
          {"label": "Réseaux sociaux"},
          {"label": "Rédaction web"},
          {"label": "Communication"},
          {"label": "Evénementiel"},
          {"label": "Communication digitale"},
          {"label": "Gestion de projet"}]
      },
      {
        id: "partnerships_manager",
        label: "Responsable Partenariats",
        baseSkills: [
          {"label": "Stratégie de communication"},
          {"label": "Réseaux sociaux"},
          {"label": "Community management"},
          {"label": "Communication digitale"},
          {"label": "Evénementiel"},
          {"label": "Gestion de projet"},
          {"label": "Partenariats"},
          {"label": "Communication"},
          {"label": "Rédaction web"},
          {"label": "Marketing de contenu"}]
      },
      {
        id: "events_project_manager",
        label: "Chef de projet événementiel",
        baseSkills: [
          {"label": "Evénementiel"},
          {"label": "Gestion de projet"},
          {"label": "Stratégie de communication"},
          {"label": "Communication"},
          {"label": "Community management"},
          {"label": "Réseaux sociaux"},
          {"label": "Management d'équipe"},
          {"label": "Communication digitale"},
          {"label": "logistique"},
          {"label": "Marketing"}]
      },
      {
        id: "journalist",
        label: "Pigiste",
        baseSkills: [
          {"label": "Rédaction"},
          {"label": "Rédaction web"},
          {"label": "Journalisme"},
          {"label": "Rédaction SEO"},
          {"label": "Réseaux sociaux"},
          {"label": "Correction"},
          {"label": "Conception rédaction"},
          {"label": "Relecture"},
          {"label": "Community management"},
          {"label": "Communication"}]
      },
      {
        id: "editorial_manager",
        label: "Content manager",
        baseSkills: [
          {"label": "Rédaction web"},
          {"label": "Réseaux sociaux"},
          {"label": "Community management"},
          {"label": "Stratégie de communication"},
          {"label": "Communication digitale"},
          {"label": "Rédaction"},
          {"label": "Marketing de contenu"},
          {"label": "Rédaction SEO"},
          {"label": "Brand content"},
          {"label": "Conception rédaction"}]
      },
      {
        id: "social_media_manager",
        label: "Social media manager",
        baseSkills: [
          {"label": "Réseaux sociaux"},
          {"label": "Community management"},
          {"label": "Stratégie de communication"},
          {"label": "Communication digitale"},
          {"label": "Instagram"},
          {"label": "Rédaction web"},
          {"label": "Facebook"},
          {"label": "Facebook Marketing"},
          {"label": "Instagram Marketing"},
          {"label": "Adobe Photoshop"}]
      },
      {
        id: "community_manager",
        label: "Community Manager",
        baseSkills: [
          {"label": "Community management"},
          {"label": "Réseaux sociaux"},
          {"label": "Rédaction web"},
          {"label": "Stratégie de communication"},
          {"label": "Communication digitale"},
          {"label": "Rédaction"},
          {"label": "Instagram"},
          {"label": "Facebook"},
          {"label": "Communication"},
          {"label": "Wordpress"}]
      },
      {
        id: "brand_manager",
        label: "Brand manager",
        baseSkills: [
          {"label": "Stratégie de communication"},
          {"label": "Branding"},
          {"label": "Gestion de projet"},
          {"label": "Brand content"},
          {"label": "Réseaux sociaux"},
          {"label": "Communication digitale"},
          {"label": "Marketing"},
          {"label": "Marketing de contenu"},
          {"label": "Community management"},
          {"label": "Evénementiel"}]
      },
      {
        id: "strategic_planner",
        label: "Planneur Stratégique",
        baseSkills: [
          {"label": "Planning stratégique"},
          {"label": "Stratégie de communication"},
          {"label": "Branding"},
          {"label": "Communication digitale"},
          {"label": "Stratégie de positionnement"},
          {"label": "Réseaux sociaux"},
          {"label": "Conception rédaction"},
          {"label": "Brand content"},
          {"label": "Marketing"},
          {"label": "Stratégie éditoriale"}]
      },
      {
        id: "media_planner",
        label: "Média Planneur",
        baseSkills: [
          {"label": "Communication digitale"},
          {"label": "Réseaux sociaux"},
          {"label": "Médias"},
          {"label": "Stratégie de communication"},
          {"label": "Marketing"},
          {"label": "Facebook Marketing"},
          {"label": "Gestion de projet"},
          {"label": "Publicité"},
          {"label": "Google Analytics"},
          {"label": "Stratégie commerciale"}]
      },
      {
        id: "webeditor",
        label: "Rédacteur web",
        baseSkills: [
          {"label": "Rédaction web"},
          {"label": "Rédaction"},
          {"label": "Rédaction SEO"},
          {"label": "SEO"},
          {"label": "Conception rédaction"},
          {"label": "Réseaux sociaux"},
          {"label": "Blog"},
          {"label": "Correction"},
          {"label": "Community management"},
          {"label": "Wordpress"}]
      },
      {
        id: "copywriter",
        label: "Concepteur Rédacteur",
        baseSkills: [
          {"label": "Rédaction"},
          {"label": "Conception rédaction"},
          {"label": "Rédaction web"},
          {"label": "Rédaction SEO"},
          {"label": "Stratégie de communication"},
          {"label": "Réseaux sociaux"},
          {"label": "Correction"},
          {"label": "Communication"},
          {"label": "Relecture"},
          {"label": "Communication digitale"}]
      },
      {
        id: "communication_consultant",
        label: "Consultant en communication",
        baseSkills: [
          {"label": "Stratégie de communication"},
          {"label": "Communication digitale"},
          {"label": "Réseaux sociaux"},
          {"label": "Gestion de projet"},
          {"label": "Community management"},
          {"label": "Evénementiel"},
          {"label": "Communication"},
          {"label": "Relations presse"},
          {"label": "Rédaction web"},
          {"label": "Rédaction"}]
      }
    ]
  },
  {
    id: uuidv4(),
    category: JobCategoryTypes.BUSINESS_CONSULTING,
    label: "Business & Conseil",
    jobs: [
      {
        id: "strategy_consultant",
        label: "Consultant stratégie digitale",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Management d'équipe"},
          {"label": "Stratégie d'entreprise"},
          {"label": "Transformation digitale"},
          {"label": "Stratégie de communication"},
          {"label": "Business development"},
          {"label": "Stratégie webmarketing"},
          {"label": "Marketing"},
          {"label": "Conseil"},
          {"label": "Stratégie commerciale"}]
      },
      {
        id: "management_consultant",
        label: "Consultant management",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Management d'équipe"},
          {"label": "Stratégie d'entreprise"},
          {"label": "Conseil"},
          {"label": "Conduite du changement"},
          {"label": "Formation"},
          {"label": "Business development"},
          {"label": "Stratégie commerciale"},
          {"label": "Business plan"},
          {"label": "Finance"}]
      },
      {
        id: "lean_management_consultant",
        label: "Consultant lean management",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Lean management"},
          {"label": "Management d'équipe"},
          {"label": "Amélioration continue"},
          {"label": "Lean six sigma"},
          {"label": "Conduite du changement"},
          {"label": "Formation"},
          {"label": "Supply chain"},
          {"label": "Stratégie d'entreprise"},
          {"label": "Facilitation de processus"}]
      },
      {
        id: "business_analyst",
        label: "Business Analyst",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Business analysis"},
          {"label": "Microsoft Excel"},
          {"label": "Finance"},
          {"label": "Business plan"},
          {"label": "Analyse de données"},
          {"label": "SQL"},
          {"label": "Méthode agile"},
          {"label": "Stratégie d'entreprise"},
          {"label": "Spécifications fonctionnelles"}]
      },
      {
        id: "bi_consultant",
        label: "Consultant BI",
        baseSkills: [
          {"label": "Qlik"},
          {"label": "Qlik Sense"},
          {"label": "SQL Server"},
          {"label": "Microsoft Power BI"},
          {"label": "Business intelligence"},
          {"label": "SQL"},
          {"label": "Oracle"},
          {"label": "Gestion de projet"},
          {"label": "SAP Business Objects"},
          {"label": "Talend"},
          {"label": "Microsoft Excel"},
          {"label": "Data visualisation"}]
      },
      {
        id: "biz_dev",
        label: "Business developers",
        baseSkills: [
          {"label": "Business development"},
          {"label": "Stratégie commerciale"},
          {"label": "Gestion de projet"},
          {"label": "Management d'équipe"},
          {"label": "Marketing"},
          {"label": "Stratégie d'entreprise"},
          {"label": "Business plan"},
          {"label": "Commercial"},
          {"label": "Négociation"},
          {"label": "Stratégie de communication"}]
      },
      {
        id: "gdpr_consultant",
        label: "Consultant RGPD / DPO",
        baseSkills: [
          {"label": "RGPD"},
          {"label": "Gestion de projet"},
          {"label": "DPO"},
          {"label": "Conseil"},
          {"label": "Audit"},
          {"label": "Formation"},
          {"label": "GDPR"},
          {"label": "Conformité"},
          {"label": "Analyse de risques"},
          {"label": "Cybersécurité"}]
      },
      {
        id: "software_package_consultant",
        label: "Consultant ERP",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "SAP"},
          {"label": "ERP"},
          {"label": "AMOA"},
          {"label": "Formation"},
          {"label": "Management d'équipe"},
          {"label": "Conseil"},
          {"label": "Finance"},
          {"label": "Comptabilité"},
          {"label": "SQL"}]
      },
      {
        id: "operation_manager",
        label: "Operation Manager",
        baseSkills: [
          {"label": "Gestion de projet"},
          {"label": "Management d'équipe"},
          {"label": "Business development"},
          {"label": "Stratégie d'entreprise"},
          {"label": "Conseil"},
          {"label": "Stratégie commerciale"},
          {"label": "Business plan"},
          {"label": "Conduite du changement"},
          {"label": "Facilitation de processus"},
          {"label": "organisation"}]
      }
    ]
  }

] as JobCategory[]


export const findByType = (catType: JobCategoryTypes) => {
  return JOBS_CATEGORIES.find((it) => it.category === catType)
}
/* ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  {
     id:uuidv4(),category: "other",
    label: "Autre",
    jobs: [
      {
         id:uuidv4(),category: "textile_designer",
        label: "Textile Designer"
      }
    ]
  }*/
